import { styled } from '@linaria/react';
import { Group } from '@mantine/core';
import type { Initiative } from '../../../../api/initiative-client/initiative-client.type';
import type { Outcome } from '../../../../api/strategy-client/strategy-client.type';
import { secondaryBase, secondaryLight, secondaryLightest } from '../../../../styles/design-tokens';
import { Tooltip } from '../../../../ui-library/tooltip/tooltip';
import { Text } from '../../../../ui-library/typography/typography';

interface ParentOutcomesCellProps {
  initiative: Initiative;
  outcomes: Outcome[];
}

export const ParentOutcomesCell = ({ initiative, outcomes }: ParentOutcomesCellProps) => {
  // Get parent outcomes by filtering outcomes that contain this initiative
  const parentOutcomes = outcomes.filter((outcome) => outcome.initiatives?.some((init) => init.id === initiative.id));

  // If no parent outcomes, return empty
  if (parentOutcomes.length === 0) {
    return null;
  }

  return (
    <Group gap={4} wrap="wrap">
      {parentOutcomes.map((outcome) => (
        <Tooltip key={outcome.id} label={outcome.name} variant="black" multiline style={{ maxWidth: 200 }}>
          <StyledTag key={outcome.id}>
            <Text size="small" style={{ color: secondaryBase, whiteSpace: 'nowrap' }}>
              {outcome.key}
            </Text>
          </StyledTag>
        </Tooltip>
      ))}
    </Group>
  );
};

const StyledTag = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 16px;
  background-color: ${secondaryLightest};
  border: 1px solid ${secondaryLight};
  white-space: nowrap;
`;
